import React, { useEffect, useState } from "react";
import { BellRing, ExternalLink, X } from "lucide-react";
import { openNewsPage } from "./amendmentNotice";
import "./AmendmentNoticeModal.css";

const SEEN_PREFIX = "loginhs:amendment-notice:seen";

function markerKey(audience) {
  if (audience !== "member") return `${SEEN_PREFIX}:public`;
  let user = "member";
  try { user = localStorage.getItem("userId") || "member"; } catch {}
  return `${SEEN_PREFIX}:${user}`;
}

/** 고시 번호별 1회 알림. X는 이번 탭만 닫고, 확인 버튼만 영구 확인 처리한다. */
export default function AmendmentNoticeModal({ notice, audience = "public" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!notice?.id) return;
    try {
      setVisible(localStorage.getItem(markerKey(audience)) !== notice.id);
    } catch {
      setVisible(true);
    }
  }, [notice?.id, audience]);

  if (!notice || !visible) return null;

  const acknowledge = () => {
    try { localStorage.setItem(markerKey(audience), notice.id); } catch {}
    setVisible(false);
  };
  const viewNews = () => {
    acknowledge();
    openNewsPage();
  };

  return (
    <div className="lhs-amendment-modal-backdrop" role="presentation">
      <section
        className="lhs-amendment-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lhs-amendment-modal-title"
      >
        <button className="lhs-amendment-modal-close" onClick={() => setVisible(false)} aria-label="이번 탭에서 닫기">
          <X size={18} />
        </button>
        <div className="lhs-amendment-modal-icon"><BellRing size={21} /></div>
        <div className="lhs-amendment-modal-kicker">품목분류 업무 알림</div>
        <h2 id="lhs-amendment-modal-title">{notice.title}</h2>
        <p>{notice.content}</p>
        <dl className="lhs-amendment-modal-stats">
          <div><dt>고시일</dt><dd>{notice.gosiDate || "—"}</dd></div>
          <div><dt>이번 고시</dt><dd>{Number(notice.changedItemCount || 0).toLocaleString()}개 항목</dd></div>
          <div><dt>검수 대기</dt><dd>{Number(notice.pendingReviewCount || 0).toLocaleString()}건</dd></div>
        </dl>
        <div className="lhs-amendment-modal-actions">
          <button className="lhs-amendment-modal-secondary" onClick={acknowledge}>확인했어요</button>
          <button className="lhs-amendment-modal-primary" onClick={viewNews}>
            공지에서 자세히 <ExternalLink size={14} />
          </button>
        </div>
        <small>같은 고시는 확인 후 다시 표시하지 않으며, 새 고시가 반영되면 다시 알려드립니다.</small>
      </section>
    </div>
  );
}
